import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const LoginForm_Box_1 = styled.div`
  margin-top: 16px;
  font-size: 16px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 24px;
  }
`;

export const LoginForm_Box_2 = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 40px;
  }
`;

export const LoginForm_Box_3 = styled.div`
  margin-bottom: 16px;
`;
